export default __webpack_public_path__ + "static/media/Cancer.98f6184e.png";